{
  "name": "@peanuts/vue-frontend",
  "description": "Peanuts Frontend Application",
  "homepage": "https://app.peanuts.nl",
  "version": "1.78.21",
  "private": true,
  "type": "module",
  "engines": {
    "node": ">=22 <=22.23.2"
  },
  "scripts": {
    "dev": "vite --host",
    "dev:acceptance": "vite --mode acceptance",
    "dev:capacitor": "vite --mode capacitor",
    "dev:production": "vite --mode production --host",
    "build": "run-p type-check \"build-only {@}\" --",
    "build-no-minify": "run-p type-check \"build-only-no-minify {@}\" --",
    "build-only": "vite build",
    "build-only-no-minify": "vite build --minify false",
    "preview": "vite preview",
    "type-check": "vue-tsc --build",
    "lint": "eslint . --fix",
    "format": "prettier --write src/",
    "format:check": "prettier --list-different src/",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build",
    "generate:sdk": "npx @openapitools/openapi-generator-cli generate -i http://localhost:8000/d/api/schema/ -g typescript-axios -o sdk && node -e \"require('fs').rmSync('sdk/docs', { recursive: true, force: true })\"",
    "postinstall": "patch-package",
    "prepare": "cd .. && husky vue-frontend/.husky"
  },
  "lint-staged": {
    "**/*.{vue,js,jsx,cjs,mjs,ts,tsx,cts,mts}": [
      "eslint --fix",
      "prettier --write"
    ]
  },
  "dependencies": {
    "@capacitor-community/file-opener": "^8.0.1",
    "@capacitor-community/safe-area": "^8.0.1",
    "@capacitor-firebase/messaging": "^8.5.2",
    "@capacitor/android": "^8.5.2",
    "@capacitor/app": "^8.1.2",
    "@capacitor/app-launcher": "^8.0.1",
    "@capacitor/core": "^8.5.2",
    "@capacitor/dialog": "^8.0.1",
    "@capacitor/file-transfer": "^2.0.6",
    "@capacitor/filesystem": "^8.1.4",
    "@capacitor/geolocation": "^8.2.3",
    "@capacitor/ios": "^8.5.2",
    "@capacitor/local-notifications": "^8.3.1",
    "@capacitor/push-notifications": "^8.1.3",
    "@capacitor/splash-screen": "^8.0.2",
    "@capawesome/capacitor-app-update": "^8.1.0",
    "@capgo/capacitor-updater": "^8.52.1",
    "@clerk/localizations": "^4.21.2",
    "@clerk/vue": "^2.5.9",
    "@fortawesome/fontawesome-svg-core": "^7.3.1",
    "@fortawesome/free-brands-svg-icons": "^7.3.1",
    "@fortawesome/free-regular-svg-icons": "^7.3.1",
    "@fortawesome/free-solid-svg-icons": "^7.3.1",
    "@fortawesome/vue-fontawesome": "^3.3.3",
    "@floating-ui/dom": "^1.8.0",
    "@googlemaps/js-api-loader": "^2.1.3",
    "@headlessui/vue": "^1.7.23",
    "@interactjs/actions": "^1.10.28",
    "@interactjs/auto-start": "^1.10.28",
    "@interactjs/interact": "^1.10.27",
    "@microsoft/applicationinsights-web": "^3.4.4",
    "@mindlib-capacitor/send-intent": "^8.0.6",
    "@primeuix/themes": "^2.0.3",
    "@sentry/capacitor": "~4.3.0",
    "@sentry/vite-plugin": "^5.4.0",
    "@sentry/vue": "10.69.0",
    "@tailwindcss/vite": "^4.3.3",
    "@tanstack/vue-virtual": "^3.13.39",
    "@thegrizzlylabs/web-geniusscan-sdk": "^6.5.1",
    "@transistorsoft/capacitor-background-fetch": "^8.1.3",
    "@transistorsoft/capacitor-background-geolocation": "^9.6.0",
    "@types/lodash-es": "^4.17.12",
    "@types/uuid": "^10.0.0",
    "@vue-leaflet/vue-leaflet": "^0.10.1",
    "@vue/devtools-api": "^8.2.1",
    "@vuelidate/core": "^2.0.3",
    "@vuelidate/validators": "^2.0.4",
    "@vuepic/vue-datepicker": "^13.0.0",
    "@vueuse/components": "^15.0.0",
    "@vueuse/core": "^15.0.0",
    "@vueuse/integrations": "^15.0.0",
    "@zoom-image/vue": "^0.2.33",
    "axios": "^1.20.0",
    "capacitor-native-settings": "^8.2.0",
    "centrifuge": "^5.7.4",
    "chart.js": "^4.5.1",
    "core-js": "^3.50.0",
    "date-fns": "^4.4.0",
    "file-type": "^22.1.1",
    "firebase": "^12.19.0",
    "fuse.js": "^7.5.0",
    "html2canvas-pro": "^2.5.0",
    "i18n-iso-countries": "^7.14.0",
    "jspdf": "^4.2.1",
    "leaflet": "^1.9.4",
    "lodash-es": "^4.18.1",
    "maska": "^3.2.2",
    "mitt": "^3.0.1",
    "moment": "^2.31.0",
    "odata-query": "^8.1.0",
    "patch-package": "^8.0.1",
    "pinia": "^4.0.3",
    "primeicons": "^7.0.0",
    "primevue": "^4.5.5",
    "register-service-worker": "^1.7.2",
    "reka-ui": "^2.11.0",
    "uuid": "^14.0.2",
    "vue": "^3.5.43",
    "vue-router": "^5.3.1",
    "vuedraggable": "^4.1.0"
  },
  "devDependencies": {
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^8.5.2",
    "@openapitools/openapi-generator-cli": "^2.41.0",
    "@semantic-release/changelog": "^7.0.0",
    "@semantic-release/exec": "^7.1.0",
    "@semantic-release/git": "^11.0.1",
    "@storybook/addon-docs": "^10.6.1",
    "@storybook/addon-mcp": "^10.6.1",
    "@storybook/addon-onboarding": "^10.6.1",
    "@storybook/vue3-vite": "^10.6.1",
    "@tailwindcss/forms": "^0.5.11",
    "@tsconfig/node22": "^22.0.6",
    "@types/google.maps": "^3.66.5",
    "@types/leaflet": "^1.9.22",
    "@types/node": "^22.20.5",
    "@vitejs/plugin-vue": "^6.0.9",
    "@vue/compiler-sfc": "^3.5.43",
    "@vue/eslint-config-prettier": "^10.2.0",
    "@vue/eslint-config-typescript": "^14.9.0",
    "@vue/tsconfig": "^0.9.1",
    "dotenv": "^18.0.5",
    "eslint": "^9.39.5",
    "eslint-plugin-storybook": "^10.6.1",
    "eslint-plugin-vue": "^10.11.1",
    "husky": "^9.1.7",
    "lint-staged": "^17.6.0",
    "npm-run-all2": "^9.0.3",
    "prettier": "^3.9.9",
    "prettier-plugin-tailwindcss": "^0.8.1",
    "sass": "^1.105.1",
    "semantic-release": "^25.0.9",
    "storybook": "^10.6.1",
    "tailwindcss": "^4.3.3",
    "tsc-files": "^1.1.4",
    "typescript": "^6.0.3",
    "vite": "^8.3.2",
    "vite-plugin-mkcert": "^2.1.0",
    "vite-plugin-pwa": "^2.0.0",
    "vite-plugin-vue-devtools": "^8.2.1",
    "vue-tsc": "^3.3.12"
  }
}
